//Install
import React, { Component } from "react";
//Install
import { Container, Row, Col } from "react-bootstrap";
//Install
import { ReactComponent as Down } from "../../Media/Icon/010.svg";

//Element
class Submenu extends Component {
    //Element
    onClick = (e) => {
        //Element
        e.preventDefault()
        //Element
        console.log(e)
        //Element
        e.target.nextElementSibling.classList.toggle("d-block")
        //Element
        e.nativeEvent.target.classList.toggle("border-0")

    }
    //Element
    render() {
        //Element
        const Content = React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB j11251 d-none" },
            //Element
            React.createElement(Container, {},
                //Element
                React.createElement(Row, {},
                    //Element
                    React.createElement(Col, { md: 12 },
                        //Element
                        React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB c008vi" },
                            //Element
                            React.createElement("ul", { className: "S6pt64 C96Q4r pEO064 a527eB x3914c" },
                                //Element
                                React.createElement("li", { className: "S6pt64 C96Q4r" },
                                    //Element
                                    React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/" },
                                        //Element
                                        "Başlangıç"
                                    )
                                ),
                                //Element
                                React.createElement("li", { className: "S6pt64 C96Q4r" },
                                    //Element
                                    React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/", onClick: this.onClick },
                                        //Element
                                        "Kurumsal",
                                        //Element
                                        React.createElement(Down, {})
                                    ),
                                    //Element
                                    React.createElement("ul", { className: "S6pt64 C96Q4r pEO064 a527eB" },
                                        //Element
                                        React.createElement("li", { className: "S6pt64 C96Q4r" },
                                            //Element
                                            React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/hakkimizda" },
                                                //Element
                                                "Hakkımızda"
                                            )
                                        ),
                                        //Element
                                        React.createElement("li", { className: "S6pt64 C96Q4r" },
                                            //Element
                                            React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/tarihce" },
                                                //Element
                                                "Tarihçe"
                                            )
                                        ),
                                        //Element
                                        React.createElement("li", { className: "S6pt64 C96Q4r" },
                                            //Element
                                            React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/subeler" },
                                                //Element
                                                "Şubeler"
                                            )
                                        ),
                                        //Element
                                        React.createElement("li", { className: "S6pt64 C96Q4r" },
                                            //Element
                                            React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/yetki-belgeleri" },
                                                //Element
                                                "Yetki Belgeleri"
                                            )
                                        )
                                    )
                                ),
                                //Element
                                React.createElement("li", { className: "S6pt64 C96Q4r" },
                                    //Element
                                    React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/", onClick: this.onClick },
                                        //Element
                                        "Sunulan Hizmetler",
                                        //Element
                                        React.createElement(Down, {})
                                    ),
                                    //Element
                                    React.createElement("ul", { className: "S6pt64 C96Q4r pEO064 a527eB" },
                                        //Element
                                        React.createElement("li", { className: "S6pt64 C96Q4r" },
                                            //Element
                                            React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/pano-imalati" },
                                                //Element
                                                "Pano İmalat"
                                            )
                                        ),
                                        //Element
                                        React.createElement("li", { className: "S6pt64 C96Q4r" },
                                            //Element
                                            React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/aydinlatma" },
                                                //Element
                                                "Aydınlatma"
                                            )
                                        ),
                                        //Element
                                        React.createElement("li", { className: "S6pt64 C96Q4r" },
                                            //Element
                                            React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/elektrik-taahhut" },
                                                //Element
                                                "Elektrik Taahhüt"
                                            )
                                        ),
                                        //Element
                                        React.createElement("li", { className: "S6pt64 C96Q4r" },
                                            //Element
                                            React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/yenilenebilir-enerji" },
                                                //Element
                                                "Yenilenebilir Enerji"
                                            )
                                        ),
                                        //Element
                                        React.createElement("li", { className: "S6pt64 C96Q4r" },
                                            //Element
                                            React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/orta-gerilim-tesisleri" },
                                                //Element
                                                "Orta Gerilim Tesisleri"
                                            )
                                        )
                                    )
                                ),
                                //Element
                                React.createElement("li", { className: "S6pt64 C96Q4r" },
                                    //Element
                                    React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/projeler" },
                                        //Element
                                        "Projeler"
                                    )
                                ),
                                //Element
                                React.createElement("li", { className: "S6pt64 C96Q4r" },
                                    //Element
                                    React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/surdurulebilirlik" },
                                        //Element
                                        "Sürdürülebilirlik"
                                    )
                                ),
                                //Element
                                React.createElement("li", { className: "S6pt64 C96Q4r" },
                                    //Element
                                    React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/kariyer" },
                                        //Element
                                        "Kariyer"
                                    )
                                ),
                                //Element
                                React.createElement("li", { className: "S6pt64 C96Q4r" },
                                    //Element
                                    React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/iletisim" },
                                        //Element
                                        "İletişim"
                                    )
                                ),
                            )
                        )
                    )
                )
            )
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default Submenu;